import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createLabourItemDefinition,
  deleteLabourItemDefinition,
} from '../api/labourItemsApi';
import { labourDefinitionKeys } from './labourDefinitionKeys';

/**
 * Mutation hook for creating labour item definitions.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export const useCreateLabourDefinition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (name: string) =>
      createLabourItemDefinition({ name: name.trim() }),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: labourDefinitionKeys.all });
    },
  });
};

/**
 * Mutation hook for deleting labour item definitions.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export const useDeleteLabourDefinition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteLabourItemDefinition(id),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: labourDefinitionKeys.all });
    },
  });
};
